import { Link } from "react-router-dom";
import "./Footer.css";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="footer">
      <div className="footer-content">
        {/* Brand */}
        <div className="footer-brand">
          <h3>LICO Technologies</h3>
          <p>
            LICO integrates sustainable power, smart real estate, world-class
            tech and entrepreneurial education, and instant healthcare into one
            seamless ecosystem. We provide training in business & technology,
            solar energy solutions, remote healthcare services, and smart real
            estate solutions across Nigeria.
          </p>

          {/* Social Media */}
          <div className="social-links">
            <a
              href="https://x.com"
              className="social-link"
              aria-label="Twitter / X"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon fontSize="small" />
            </a>

            <a
              href="https://linkedin.com"
              className="social-link"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon fontSize="small" />
            </a>

            <a
              href="https://facebook.com"
              className="social-link"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon fontSize="small" />
            </a>

            <a
              href="https://instagram.com"
              className="social-link"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon fontSize="small" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/services">Services</Link>
          {/* <Link to="/training">Training</Link> */}
          <Link to="/products">Products</Link>
          <Link to="/blog">Blog</Link>
          <a href="/contact-us">Contact</a>
        </div>

        {/* What We Offer */}
        <div className="footer-section">
          <h4>What We Offer</h4>
          <Link to="/services/training">Business & Technical Training</Link>
          <Link to="/services/solar">Solar Services</Link>
          <Link to="/services/healthcare">Healthcare</Link>
          <Link to="/services/real-estate">Real Estate</Link>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h4>Contact Us</h4>
          <a href="mailto:support@learnandinnovatespace.com">support@learnandinnovatespace.com</a>
          <a href="tel:+2349078801125">+234 907 880 1125</a>
          <span>No. 75 Chime Avenue, New Haven, Enugu State, Nigeria</span>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>
          &copy; {currentYear} LICO Technologies — Learn & Innovate. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
